export const STARTSAVINGSCORMPROGRESS = 'STARTSAVINGSCORMPROGRESS'